import React from 'react';
import { isSameDay } from 'date-fns';
import DayCell from './DayCell';
import { parseLocalDate } from '../../utils/dateUtils';

const CalendarGrid = ({ daysInMonth, tasks, onAddTask, onTaskClick }) => {
    const weekDays = [
        { full: 'Sunday', short: 'Sun', letter: 'S' },
        { full: 'Monday', short: 'Mon', letter: 'M' },
        { full: 'Tuesday', short: 'Tue', letter: 'T' },
        { full: 'Wednesday', short: 'Wed', letter: 'W' },
        { full: 'Thursday', short: 'Thu', letter: 'T' },
        { full: 'Friday', short: 'Fri', letter: 'F' },
        { full: 'Saturday', short: 'Sat', letter: 'S' }
    ];

    // Get tasks for a specific date
    const getTasksForDate = (date) => {
        return tasks.filter(task => {
            const taskDate = parseLocalDate(task.dueDate);
            return isSameDay(taskDate, date);
        });
    };

    return (
        <div className="calendar-grid">
            {/* Week day headers */}
            <div className="grid grid-cols-7 gap-px bg-gray-300 dark:bg-gray-600 rounded-t-lg overflow-hidden">
                {weekDays.map((day) => (
                    <div
                        key={day.full}
                        className="bg-gray-100 dark:bg-gray-700 py-2 sm:py-3 text-center text-xs sm:text-sm font-semibold text-gray-700 dark:text-gray-300"
                    >
                        <span className="hidden md:inline">{day.full}</span>
                        <span className="hidden sm:inline md:hidden">{day.short}</span>
                        <span className="sm:hidden">{day.letter}</span>
                    </div>
                ))}
            </div>

            {/* Calendar days */}
            <div className="grid grid-cols-7 gap-px bg-gray-300 dark:bg-gray-600 rounded-b-lg overflow-hidden min-h-[400px] md:min-h-[600px]">
                {daysInMonth.map((day, index) => (
                    <DayCell
                        key={index}
                        day={day}
                        tasks={day.date ? getTasksForDate(day.date) : []}
                        onAddTask={onAddTask}
                        onTaskClick={onTaskClick}
                    />
                ))}
            </div>
        </div>
    );
};

export default CalendarGrid;